import React from 'react';
import BotWidget from './BotWidget';
import DrawerBotWidget from './DrawerBotWidget';
import { useBotAgentAvailability } from './hooks/useBotAgentAvailability';

/**
 * Mount-level gate for the bot agent widget.
 *
 * When the feature is unavailable for the current tenant / agency / website,
 * nothing renders — no widget DOM, no session-create API call, no socket
 * connection. The host app behaves exactly as it did before bot-agent existed.
 *
 * Availability is resolved by `useBotAgentAvailability` which honors:
 *   - Site config `modulesConfigs.bot_agent.enabled` (from /b2c/site/config)
 *   - Backend composite eligibility (/ms/bot-agent/availability):
 *       agency.settings + website.configuration + tenant.llm_config
 */
const BotWidgetGate: React.FC<{ isDesktop: boolean }> = ({ isDesktop }) => {
  const { available, loading, whatsapp } = useBotAgentAvailability();

  if (loading || !available) {
    return null;
  }

  return isDesktop ? (
    <DrawerBotWidget whatsapp={whatsapp} />
  ) : (
    <BotWidget whatsapp={whatsapp} />
  );
};

export default BotWidgetGate;
